import {
	getMinWidth,
	SIZE_CINEMA,
	SIZE_DESKTOP,
	SIZE_MOBILE,
	SIZE_TABLET,
} from "@escapio/portal/dom/screen";

export const HOTEL_IMAGE_MAX_SIZE = "hotel_image_max_size";
export const ARTICLE_IMAGE_MAX_SIZE = "article_image_max_size";

export const LIST_HOTEL_ELEMENT_MOBILE = "list_hotel_element_mobile";
export const LIST_HOTEL_ELEMENT_TABLET = "list_hotel_element_tablet";
export const LIST_CONTEXT_CRITERIA = "list_context_criteria";
export const LIST_CONTEXT_CRITERIA_POPUP = "list_context_criteria_popup";
export const LIST_SEO_IMAGE = "list_seo_image";

export const PROFILE_STAGE_MOBILE = "profile_stage_mobile";
export const PROFILE_STAGE_TABLET_SMALL_STAGE =
	"profile_stage_tablet_small_stage";
export const PROFILE_STAGE_TABLET_BIG_STAGE_FIRST_PIC =
	"profile_stage_tablet_big_stage_first_pic";
export const PROFILE_STAGE_TABLET_BIG_STAGE_OTHER_PICS =
	"profile_stage_tablet_big_stage_other_pics";
export const PROFILE_TRAVEL_EXPERT_PICTURE = "profile_travel_expert_picture";
export const PROFILE_GALLERY = "profile_gallery";
export const PROFILE_GALLERY_PREVIEW = "profile_gallery_preview";
export const PROFILE_GALLERY_THUMBNAILS = "profile_gallery_thumbnails";

export const HOME_FEATURED_DEALS = "home_featured_deals";
export const HOME_FEATURED_HOTELS = "home_featured_hotels";
export const HOME_FEATURED_LINKS = "home_featured_links";

export const RESULT_AD_BANNER = "result_ad_banner";

export const ARTICLE_DEAL_MOBILE = "article_deal_MOBILE";
export const ARTICLE_DEAL_TABLET = "article_deal_TABLET";

export const CHECKOUT_HOTEL_PICTURE = "checkout_hotel_picture";

export const MARKDOWN_IMAGES_SMALL = "markdown_images_small";
export const MARKDOWN_IMAGES_MEDIUM = "markdown_images_medium";
export const MARKDOWN_IMAGES_DEFAULT = "markdown_images_default";

export const NEWSLETTER_POPUP = "newsletter_popup";
export const NEWSLETTER_CONTEST_TERMS = "newsletter_contest_terms_page";

export const CMS_HOTEL_DEFAULT_SIZE = "cms_hotel_default_size";
export const CMS_HOTEL_PICTURES_CROP_DIALOG = "cms_hotel_crop_dialog";
export const CMS_FEATURED_LINKS = "cms_featured_links";

const PORTRAIT = "portrait";
const LANDSCAPE = "landscape";
const ANY_ORIENTATION = "any";

export const getSizesPerSource = key => {
	const data = SIZE_MAP[key];
	if (!data) {
		throw Error(`Unknown picture sizes-key '${key}'`);
	}
	const { fallBackSize, sourcesData } = Object.entries(data.sizes).reduce(
		(acc, [orientationKey, currOrientationSizes]) => {
			Object.entries(currOrientationSizes)
				.reverse()
				.forEach(([min, size]) => {
					const mediaQuery = {
						[ANY_ORIENTATION]: `(min-width: ${min}px)`,
						[PORTRAIT]: `(orientation: portrait) and (min-width: ${min}px)`,
						[LANDSCAPE]: `(orientation: landscape) and (min-height: ${min}px)`,
					}[orientationKey];

					acc.fallBackSize = size;
					acc.sourcesData.push({
						mediaQuery,
						size: size,
						min,
					});
				});
			return acc;
		},
		{ sourcesData: [] },
	);

	return { type: data.type, fallBackSize, sourcesData };
};

/*
 * Notice: the sizes defined here must match the allow-list in the web-app-images project.
 * Also some values are defined in PHP enum 'PictureCacheKey'
 *
 * Note that the order is very important
 * here! The first source that matches will be used, that's why the
 * larger resolutions are listed first.
 */
const maxSize = "5000x";
const SIZE_MAP = {
	[HOTEL_IMAGE_MAX_SIZE]: {
		sizes: { [ANY_ORIENTATION]: { 0: maxSize } },
		type: "hotel",
	},
	[ARTICLE_IMAGE_MAX_SIZE]: {
		sizes: { [ANY_ORIENTATION]: { 0: maxSize } },
		type: "article",
	},

	[LIST_HOTEL_ELEMENT_MOBILE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "568x284" } },
		type: "hotel",
	},
	[LIST_HOTEL_ELEMENT_TABLET]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "251x251" } },
		type: "hotel",
	},
	[LIST_CONTEXT_CRITERIA]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_TABLET)]: "100x100" } },
		type: "hotel",
	},
	[LIST_CONTEXT_CRITERIA_POPUP]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_TABLET)]: "800x" } },
		type: "hotel",
	},
	[LIST_SEO_IMAGE]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "670x120",
				[getMinWidth(SIZE_DESKTOP)]: "740x260",
			},
		},
		type: "hotel",
	},

	[PROFILE_STAGE_MOBILE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "300x200" } },
		type: "hotel",
	},
	[PROFILE_STAGE_TABLET_SMALL_STAGE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_TABLET)]: "320x320" } },
		type: "hotel",
	},
	[PROFILE_STAGE_TABLET_BIG_STAGE_FIRST_PIC]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_TABLET)]: "733x400" } },
		type: "hotel",
	},
	[PROFILE_STAGE_TABLET_BIG_STAGE_OTHER_PICS]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_TABLET)]: "231x189" } },
		type: "hotel",
	},
	[PROFILE_TRAVEL_EXPERT_PICTURE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "170x170" } },
		type: "hotel",
	},
	[PROFILE_GALLERY_PREVIEW]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "300x300" } },
		type: "hotel",
	},
	[PROFILE_GALLERY_THUMBNAILS]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "60x60",
				[getMinWidth(SIZE_TABLET)]: "100x100",
			},
		},
		type: "hotel",
	},
	[PROFILE_GALLERY]: {
		sizes: {
			[PORTRAIT]: {
				0: "720x",
				721: "840x",
				841: "1280x",
				1281: "1536x",
				1537: "2560x",
			},
			[LANDSCAPE]: {
				0: "x500",
				501: "x600",
				601: "x800",
				801: "x1100",
				1101: "x2200",
			},
		},
		type: "hotel",
	},

	[HOME_FEATURED_DEALS]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "568x284" } },
		type: "hotel",
	},
	[HOME_FEATURED_HOTELS]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "568x284",
				[getMinWidth(SIZE_TABLET)]: "400x300",
				[getMinWidth(SIZE_DESKTOP)]: "231x174",
			},
		},
		type: "hotel",
	},
	[HOME_FEATURED_LINKS]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "269x202",
				[getMinWidth(SIZE_TABLET)]: "186x140",
				[getMinWidth(SIZE_DESKTOP)]: "231x174",
			},
		},
		type: "article",
	},

	[CHECKOUT_HOTEL_PICTURE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "550x" } },
		type: "hotel",
	},

	[RESULT_AD_BANNER]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "547x306",
				[getMinWidth(SIZE_TABLET)]: "802x448",
			},
		},
		type: "article",
	},

	[ARTICLE_DEAL_MOBILE]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "568x284" } },
		type: "article",
	},
	[ARTICLE_DEAL_TABLET]: {
		sizes: { [ANY_ORIENTATION]: { [getMinWidth(SIZE_MOBILE)]: "251x251" } },
		type: "article",
	},

	[MARKDOWN_IMAGES_DEFAULT]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "670x120",
				[getMinWidth(SIZE_DESKTOP)]: "740x260",
			},
		},
		type: "hotel",
	},
	[MARKDOWN_IMAGES_SMALL]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "670x",
				[getMinWidth(SIZE_DESKTOP)]: "185x",
			},
		},
		type: "hotel",
	},
	[MARKDOWN_IMAGES_MEDIUM]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "670x",
				[getMinWidth(SIZE_DESKTOP)]: "370x",
			},
		},
		type: "hotel",
	},

	[NEWSLETTER_POPUP]: {
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "567x",
				[getMinWidth(SIZE_TABLET)]: "400x",
			},
		},
		type: "article",
	},
	[NEWSLETTER_CONTEST_TERMS]: {
		type: "article",
		sizes: {
			[ANY_ORIENTATION]: {
				[getMinWidth(SIZE_MOBILE)]: "567x",
				[getMinWidth(SIZE_TABLET)]: "812x",
				[getMinWidth(SIZE_DESKTOP)]: "1023x",
				[getMinWidth(SIZE_CINEMA)]: "1920x",
			},
		},
	},

	[CMS_HOTEL_DEFAULT_SIZE]: {
		sizes: { [ANY_ORIENTATION]: { 0: "x500" } },
		type: "hotel",
	},
	[CMS_HOTEL_PICTURES_CROP_DIALOG]: {
		sizes: { [ANY_ORIENTATION]: { 0: "600x" } },
		type: "hotel",
	},
	[CMS_FEATURED_LINKS]: {
		sizes: { [ANY_ORIENTATION]: { 0: "231x174" } },
		type: "hotel",
	},
};
